import React, { useState } from 'react'
import { DataTable, DataTableRow, Divider, Expander, ExpanderContent, ExpanderHeader, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ContentLock, ContentUnlock } from '@fs/zion-icon'

export default function OdmRecordNotes({ notes }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  const getRestrictedIcon = (isRestricted) => {
    if (isRestricted) {
      return <ContentLock size="sm" color="red" />
    }
    return <ContentUnlock size="sm" color="green" />
  }

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.notes', 'Notes')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {notes && notes.length > 0 && (
            <DataTable
              columns={[
                { label: t('odm.note.restrict', 'Restrict Note'), size: 'xs' },
                { label: t('odm.note.source', 'Source'), size: 'sm' },
                { label: t('odm.note.attachedField', 'Field Note Is Attached To'), size: 'md' },
                { label: t('odm.note.text', 'Note Text'), size: 'lg' },
              ]}
            >
              {notes.map((note) => {
                return (
                  <DataTableRow
                    key={note.id}
                    column1={getRestrictedIcon(note.restricted)}
                    column2={note.source}
                    column3={note.field}
                    column4={note.data}
                  />
                )
              })}
            </DataTable>
          )}
          {!notes || (notes.length <= 0 && <p>{t('odm.noNotes', 'No Notes')}</p>)}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
